// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IW5z","rootMobile":"styles_rootMobile__1joFO"};